import axios from "axios";

function resolveBaseURL() {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL;
  }
  return "https://peisong.zy10086.cn/api";
}

const http = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 15000,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("ps_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default http;
